import { Accordion } from '@/components/Accordion/Accordion';
import { AccordionItem } from '@/components/Accordion/AccordionItem';
import { AccordionHeader } from '@/components/Accordion/AccordionHeader';
import { Button } from '@/components/Button/Button';
import { Modal } from '@/components/Modal/Modal';
import { analyticsEventHandlers } from '@/lib/analytics/events/generalAnalyticsEvents';

type FAQ = { question: string; answer: string };

type FAQList = Array<FAQ>;

type FAQGroup = { category: string; category_faqs: FAQList };

export type FAQs = Array<FAQGroup>;

type FAQsModalProps = { buttonLabel: string; modalTitle: string; faqs: FAQs };

export const FAQsModal = ({ buttonLabel, modalTitle, faqs }: FAQsModalProps) => {
	return (
		<Modal
			variant="flyout"
			title={modalTitle}
			modalTriggerAsChild
			modalTriggerChild={
				<Button
					data-testid="help-widget__faq-button"
					variant="tertiary"
					theme="dark"
					icon="arrow-right"
					iconPosition="right"
					iconSize="1em"
				>
					{buttonLabel}
				</Button>
			}
			onOpenChange={(open) => {
				if (open) {
					analyticsEventHandlers.trackHelpWidgetFAQsClicked();
				} else {
					analyticsEventHandlers.trackHelpWidgetFAQsClosed();
				}
			}}
		>
			{faqs.map((faq) => (
				<div key={faq.category} className="mb-xl">
					<Accordion>
						<AccordionHeader>{faq.category}</AccordionHeader>
						{faq.category_faqs.map((faq_item) => (
							<AccordionItem
								key={faq_item.question}
								title={faq_item.question}
								onExpandedChange={({ isExpanded, title }) => {
									if (isExpanded) {
										analyticsEventHandlers.trackHelpWidgetFAQSectionOpened(String(title));
									} else {
										analyticsEventHandlers.trackHelpWidgetFAQSectionClosed(String(title));
									}
								}}
							>
								<div className="flow color-text-tertiary">{faq_item.answer}</div>
							</AccordionItem>
						))}
					</Accordion>
				</div>
			))}
		</Modal>
	);
};
